import makeCrudModule from '@/factories/CrudModelFactory';
import landingpagesService from '@/services/revisions';

export default makeCrudModule({
    service: landingpagesService,
    dateConvert: [
        'created_at', 'updated_at'
    ]
});
